import React from "react";
import { sanitizeRichText } from "@/lib/content";

export const RichTextContent = ({ html, className = "", testId }) => {
  const safeHtml = sanitizeRichText(html);

  if (!safeHtml) {
    return null;
  }

  return (
    <div
      className={className}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
};

export default RichTextContent;